import React, { useState } from "react";
import styles from "./inputComponent.module.scss";
import EyeOff from "../../assets/images/login/eyeoff.png";
import EyeOn from "../../assets/images/login/oneye.png";

interface InputComponentProps {
  label?: string;
  type: string;
  name: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isPassword?: boolean;
  isShowPassword?: boolean;
  toggleShowPassword?: () => void;
  error?: string;
  maxLength?: number;
  autoComplete?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const InputComponent: React.FC<InputComponentProps> = ({
  label,
  type,
  name,
  placeholder,
  maxLength,
  value,
  onChange,
  onBlur,
  isPassword = false,
  isShowPassword,
  toggleShowPassword,
  error,
  autoComplete,
}) => {
  const [internalShowPassword, setInternalShowPassword] = useState<boolean>(false);

  const isPasswordField = isPassword || type === "password";

  const effectiveShowPassword =
    typeof isShowPassword === "boolean"
      ? isShowPassword
      : internalShowPassword;

  const handleToggle = () => {
    if (toggleShowPassword) {
      toggleShowPassword();
    } else {
      setInternalShowPassword((prev) => !prev);
    }
  };

  const inputType = isPasswordField
    ? effectiveShowPassword
      ? "text"
      : "password"
    : type;

  return (
    <div className={styles.input_container}>
      {label && <p className={styles.inputText}>{label}</p>}
      <div className={styles.input_control}>
        <input
          style={{ color: "#000" }}
          type={inputType}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          maxLength={maxLength}
          autoComplete={autoComplete ? "new-password" : ""}
          className={isPasswordField ? styles.passwordInput : ""}
        />
        {isPasswordField && (
          <div
            onClick={handleToggle}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleToggle();
              }
            }}
            className={styles.passwordIcon}
            role="button"
            tabIndex={0}
            aria-label={
              effectiveShowPassword ? "Şifrəni gizlət" : "Şifrəni göstər"
            }
          >
            <img
              src={effectiveShowPassword ? EyeOff : EyeOn}
              alt={effectiveShowPassword ? "Hide password" : "Show password"}
            />
          </div>
        )}
      </div>
      {error ? (
        <p
          className={`${styles.errorMessage} ${
            error ? styles.visible : styles.hidden
          }`}
        >
          {error}
        </p>
      ) : (
        <p className={styles.hidden}>empty</p>
      )}
    </div>
  );
};

export default InputComponent;
